import React from 'react';

import RangeSlider from '../../Default/RangeSlider';
import RadioButton from '../../Default/RadioButton';
import { ResizeBehaviour } from '../../../../Game/Level/Blok/State';

import { displayNumber } from '../../../helpers/numberHelpers';

export default function GrowthShrinkage({ updateBlokStateSettings, resizeBehaviour, resizeSpeed, resizeWidth, resizeHeight }) {
    return (
        <div className="side-bar-page-content">
            <div className="side-bar-row">
                <RadioButton
                    name="resizeBehaviour"
                    value={ResizeBehaviour.none}
                    activeValue={resizeBehaviour}
                    onChange={e =>
                        updateBlokStateSettings({
                            resizeBehaviour: parseInt(e.target.value, 10)
                        })
                    }
                >
                    Geen
                </RadioButton>
            </div>
            <hr />
            <div className="side-bar-row side-bar-row-title">Vanuit het midden</div>
            <div className="side-bar-row">
                <RadioButton
                    name="resizeBehaviour"
                    value={ResizeBehaviour.backAndForth}
                    activeValue={resizeBehaviour}
                    onChange={e =>
                        updateBlokStateSettings({
                            resizeBehaviour: parseInt(e.target.value, 10)
                        })
                    }
                >
                    Heen en weer
                </RadioButton>
                <RadioButton
                    name="resizeBehaviour"
                    value={ResizeBehaviour.once}
                    activeValue={resizeBehaviour}
                    onChange={e =>
                        updateBlokStateSettings({
                            resizeBehaviour: parseInt(e.target.value, 10)
                        })
                    }
                >
                    Maar 1 keer
                </RadioButton>
            </div>
            <hr />
            <div className="side-bar-row side-bar-row-title">Tempo</div>
            <div className="side-bar-row" style={{ marginBottom: -5 }}>
                <RangeSlider
                    currentValue={resizeSpeed}
                    min={0}
                    max={20}
                    step={0.1}
                    sliderStep={1}
                    disabled={resizeBehaviour !== ResizeBehaviour.backAndForth && resizeBehaviour !== ResizeBehaviour.once}
                    onChange={v =>
                        updateBlokStateSettings({
                            resizeSpeed: v
                        })
                    }
                    valueOnSide
                />
            </div>
            <hr />
            <div className="side-bar-row side-bar-row-title">Groter of kleiner</div>
            <div className="side-bar-row" style={{ marginBottom: 0 }}>
                Smaller/Breder
            </div>
            <div className="side-bar-row" style={{ marginBottom: 0 }}>
                <RangeSlider
                    currentValue={resizeWidth}
                    description={v => `${displayNumber(v * 100, 0)}%`}
                    min={0.1}
                    max={2}
                    step={0.01}
                    sliderStep={0.1}
                    precision={2}
                    disabled={resizeBehaviour !== ResizeBehaviour.backAndForth && resizeBehaviour !== ResizeBehaviour.once}
                    onChange={v =>
                        updateBlokStateSettings({
                            resizeWidth: v
                        })
                    }
                    valueOnSide
                />
            </div>
            <div className="side-bar-row" style={{ marginTop: 0, marginBottom: 0 }}>
                Lager/Hoger
            </div>
            <div className="side-bar-row">
                <RangeSlider
                    currentValue={resizeHeight}
                    description={v => `${displayNumber(v * 100, 0)}%`}
                    min={0.1}
                    minDisplay="10%"
                    max={2}
                    maxDisplay="200%"
                    step={0.01}
                    sliderStep={0.1}
                    precision={2}
                    disabled={resizeBehaviour !== ResizeBehaviour.backAndForth && resizeBehaviour !== ResizeBehaviour.once}
                    onChange={v =>
                        updateBlokStateSettings({
                            resizeHeight: v
                        })
                    }
                    valueOnSide
                />
            </div>
        </div>
    );
}
